"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _EntityUploadTypes = _interopRequireDefault(require("../model/EntityUploadTypes"));
var _PatientScanDto = _interopRequireDefault(require("../model/PatientScanDto"));
var _PatientScanDtoPaginatedList = _interopRequireDefault(require("../model/PatientScanDtoPaginatedList"));
var _PatientScanMetadataDto = _interopRequireDefault(require("../model/PatientScanMetadataDto"));
var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* PatientScansMetadata service.
* @module 1/PatientScansMetadataApi
* @version 6.3.0
*/
var PatientScansMetadataApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PatientScansMetadataApi. 
  * @alias module:1/PatientScansMetadataApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PatientScansMetadataApi(apiClient) {
    _classCallCheck(this, PatientScansMetadataApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Deletes the metadata of the specified patient scan. (Requires: Roles -> RH.PS.Delete, SIASS.PS.D, SIASS.PS.Admin).
   * This operation is only allowed for orphan metadata.
   * @param {String} id The patient scan identifier.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */
  _createClass(PatientScansMetadataApi, [{
    key: "patientscansIdMetadataDeleteWithHttpInfo",
    value: function patientscansIdMetadataDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdMetadataDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/patientscans/{id}/metadata', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the metadata of the specified patient scan. (Requires: Roles -> RH.PS.Delete, SIASS.PS.D, SIASS.PS.Admin).
     * This operation is only allowed for orphan metadata.
     * @param {String} id The patient scan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "patientscansIdMetadataDelete",
    value: function patientscansIdMetadataDelete(id) {
      return this.patientscansIdMetadataDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the metadata of the specified patient scan (incl. patient information, if available).  When the manual upload has finished and a response was received, there may still be a delay  of a few seconds until the patient scan can be retrieved. When uploading a patient scan,  Patient Scan Provisioning Service receives a message and persists the non-phi metadata like  `DateTimeUploaded` which is available after a few milliseconds.  Afterwards, RHS persists DICOM metadata which can take a few seconds. (Requires: Roles -> RH.PS.Read, SIASS.PS.R, SIASS.PS.L, SIASS.PS.Admin).
     * @param {String} id The patient scan identifier.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.dicomTags Dicom tags to be included in the metadata. Pattern must be '(GGGG,EEEE)'. Invalid or not available tags are ignored.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanDto} and HTTP response
     */
  }, {
    key: "patientscansIdMetadataGetWithHttpInfo",
    value: function patientscansIdMetadataGetWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdMetadataGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'dicomTags': this.apiClient.buildCollectionParam(opts['dicomTags'], 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientScanDto["default"];
      return this.apiClient.callApi('/patientscans/{id}/metadata', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the metadata of the specified patient scan (incl. patient information, if available).  When the manual upload has finished and a response was received, there may still be a delay  of a few seconds until the patient scan can be retrieved. When uploading a patient scan,  Patient Scan Provisioning Service receives a message and persists the non-phi metadata like  `DateTimeUploaded` which is available after a few milliseconds.  Afterwards, RHS persists DICOM metadata which can take a few seconds. (Requires: Roles -> RH.PS.Read, SIASS.PS.R, SIASS.PS.L, SIASS.PS.Admin).
     * @param {String} id The patient scan identifier.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.dicomTags Dicom tags to be included in the metadata. Pattern must be '(GGGG,EEEE)'. Invalid or not available tags are ignored.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanDto}
     */
  }, {
    key: "patientscansIdMetadataGet",
    value: function patientscansIdMetadataGet(id, opts) {
      return this.patientscansIdMetadataGetWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modifies the additional data section of patient scans metadata.  The additional data will be updated and appended.  When called concurrently, the last write operation wins. (Requires: Roles -> SIASS.PS.U, SIASS.PS.Admin).
     * @param {String} id The identifier.
     * @param {Object.<String, Object>} body The modified additional data. Must be a valid JSON object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanMetadataDto} and HTTP response
     */
  }, {
    key: "patientscansIdMetadataPatchWithHttpInfo",
    value: function patientscansIdMetadataPatchWithHttpInfo(id, body) {
      var postBody = body;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdMetadataPatch");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling patientscansIdMetadataPatch");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json', 'text/json', 'application/_*+json'];
      var accepts = ['application/json'];
      var returnType = _PatientScanMetadataDto["default"];
      return this.apiClient.callApi('/patientscans/{id}/metadata', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modifies the additional data section of patient scans metadata.  The additional data will be updated and appended.  When called concurrently, the last write operation wins. (Requires: Roles -> SIASS.PS.U, SIASS.PS.Admin).
     * @param {String} id The identifier.
     * @param {Object.<String, Object>} body The modified additional data. Must be a valid JSON object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanMetadataDto}
     */
  }, {
    key: "patientscansIdMetadataPatch",
    value: function patientscansIdMetadataPatch(id, body) {
      return this.patientscansIdMetadataPatchWithHttpInfo(id, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Replaces the additional data section of patient scans metadata.  When called concurrently, the last write operation wins.  ATTENTION: Use the PATCH route in favour of this route for nearly all use-cases!  It works the same way and does not pose the risk to overwrite data needed by other parts of the system. (Requires: Roles -> SIASS.PS.U, SIASS.PS.Admin).
     * @param {String} id The identifier.
     * @param {Object.<String, Object>} body The additional data replacement. Must be a valid JSON object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanMetadataDto} and HTTP response
     */
  }, {
    key: "patientscansIdMetadataPutWithHttpInfo",
    value: function patientscansIdMetadataPutWithHttpInfo(id, body) {
      var postBody = body;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientscansIdMetadataPut");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling patientscansIdMetadataPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json', 'text/json', 'application/_*+json'];
      var accepts = ['application/json'];
      var returnType = _PatientScanMetadataDto["default"];
      return this.apiClient.callApi('/patientscans/{id}/metadata', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Replaces the additional data section of patient scans metadata.  When called concurrently, the last write operation wins.  ATTENTION: Use the PATCH route in favour of this route for nearly all use-cases!  It works the same way and does not pose the risk to overwrite data needed by other parts of the system. (Requires: Roles -> SIASS.PS.U, SIASS.PS.Admin).
     * @param {String} id The identifier.
     * @param {Object.<String, Object>} body The additional data replacement. Must be a valid JSON object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanMetadataDto}
     */
  }, {
    key: "patientscansIdMetadataPut",
    value: function patientscansIdMetadataPut(id, body) {
      return this.patientscansIdMetadataPutWithHttpInfo(id, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of patient scan metadata. (Requires: Roles -> RH.PS.ReadList, SIASS.PS.L, SIASS.PS.Admin).
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.dicomTags Dicom tags to be included in the metadata. Pattern must be '(GGGG,EEEE)'. Invalid or not available tags are ignored.
     * @param {Array.<String>} opts.uploader Filter by uploader of a patient scan. This can be a user Id (email address),              an Azure Application Id, or a scan facility identifier.
     * @param {Array.<module:model/EntityUploadTypes>} opts.uploadType Filter by the type of upload.
     * @param {Date} opts.dateTimeFrom The start date for retrieving patient scans.
     * @param {Date} opts.dateTimeTo The end date for retrieving patient scans.
     * @param {String} opts.additionalDataFilter The additional data filter.              <br>              Must be a valid, flat JSON object or array. For example. ``` { \"jointReplacement.tpr\": null }``` will find all available patient scans. ```{ \"jointReplacement.tpr.assigned\": true }``` will find all assigned scans.              <br>              If the object or array contains more then one property, the search criteria is \"AND\" connected. All filtering is exact-match only.              <br>              When adding additional data, <b> numbers must be added strings </b> for the search to work. Booleans must be added as booleans.              <br>              DateTime filters must be exact string matches including all digits in order to work.              
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientScanDtoPaginatedList} and HTTP response
     */
  }, {
    key: "patientscansMetadataGetWithHttpInfo",
    value: function patientscansMetadataGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'dicomTags': this.apiClient.buildCollectionParam(opts['dicomTags'], 'multi'),
        'uploader': this.apiClient.buildCollectionParam(opts['uploader'], 'multi'),
        'uploadType': this.apiClient.buildCollectionParam(opts['uploadType'], 'multi'),
        'dateTimeFrom': opts['dateTimeFrom'],
        'dateTimeTo': opts['dateTimeTo'],
        'additionalDataFilter': opts['additionalDataFilter'],
        'pageIndex': opts['pageIndex'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientScanDtoPaginatedList["default"];
      return this.apiClient.callApi('/patientscans/metadata', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of patient scan metadata. (Requires: Roles -> RH.PS.ReadList, SIASS.PS.L, SIASS.PS.Admin).
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.dicomTags Dicom tags to be included in the metadata. Pattern must be '(GGGG,EEEE)'. Invalid or not available tags are ignored.
     * @param {Array.<String>} opts.uploader Filter by uploader of a patient scan. This can be a user Id (email address),              an Azure Application Id, or a scan facility identifier.
     * @param {Array.<module:model/EntityUploadTypes>} opts.uploadType Filter by the type of upload.
     * @param {Date} opts.dateTimeFrom The start date for retrieving patient scans.
     * @param {Date} opts.dateTimeTo The end date for retrieving patient scans.
     * @param {String} opts.additionalDataFilter The additional data filter.              <br>              Must be a valid, flat JSON object or array. For example. ``` { \"jointReplacement.tpr\": null }``` will find all available patient scans. ```{ \"jointReplacement.tpr.assigned\": true }``` will find all assigned scans.              <br>              If the object or array contains more then one property, the search criteria is \"AND\" connected. All filtering is exact-match only.              <br>              When adding additional data, <b> numbers must be added strings </b> for the search to work. Booleans must be added as booleans.              <br>              DateTime filters must be exact string matches including all digits in order to work.              
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientScanDtoPaginatedList}
     */
  }, {
    key: "patientscansMetadataGet",
    value: function patientscansMetadataGet(opts) {
      return this.patientscansMetadataGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return PatientScansMetadataApi;
}();
exports["default"] = PatientScansMetadataApi;